var map = {
	"./browser": 1060,
	"./browser.js": 1060,
	"./cake": 1061,
	"./cake.js": 1061,
	"./coffee-script": 154,
	"./coffee-script.js": 154,
	"./command": 1062,
	"./command.js": 1062,
	"./grammar": 1063,
	"./grammar.js": 1063,
	"./helpers": 137,
	"./helpers.js": 137,
	"./index": 1064,
	"./index.js": 1064,
	"./lexer": 469,
	"./lexer.js": 469,
	"./nodes": 470,
	"./nodes.js": 470,
	"./optparse": 471,
	"./optparse.js": 471,
	"./parser": 682,
	"./parser.js": 682,
	"./register": 683,
	"./register.js": 683,
	"./repl": 472,
	"./repl.js": 472,
	"./rewriter": 684,
	"./rewriter.js": 684,
	"./scope": 685,
	"./scope.js": 685,
	"./sourcemap": 686,
	"./sourcemap.js": 686
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 681;



//////////////////
// WEBPACK FOOTER
// ./~/coffee-script/lib/coffee-script ^\.\/.*$
// module id = 681
// module chunks = 0